// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const CloudUploadOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_4439)"},"children":[{"tag":"path","attrs":{"d":"M19.35 10.04a7.49 7.49 0 00-14-2A6 6 0 006 20h13a4.98 4.98 0 00.35-9.96zM19 18H6a4 4 0 01-.44-7.97l1.07-.11.5-.95a5.5 5.5 0 0110.26 1.46l.3 1.5 1.53.11A2.98 2.98 0 0119 18zM8 13h2.55v3h2.9v-3H16l-4-4-4 4z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_4439"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"cloud_upload","theme":"outlined"};

const CloudUploadOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={CloudUploadOutlinedSvg} />;
  CloudUploadOutlined.displayName = 'CloudUploadOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(CloudUploadOutlined);
